import toast from "react-hot-toast"

export const errorToast = (errorToastMessage: string) => toast.error(errorToastMessage)
